var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEffort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.856,
    height: 84.501,
    viewBox: "0 0 67.856 84.501",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-7{fill:#f9c295}.cls-10{fill:#fd9811}.cls-11{fill:#dce0e5}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "effort",
    transform: "translate(-50.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3039",
    fill: "#ebeef2",
    d: "M142.6 9.556a44.124 44.124 0 0 0-4.2-8.99 1.237 1.237 0 0 0-1.2-.555 44.106 44.106 0 0 0-9.562 2.651c-6.786 2.727-11.568 6.764-13.83 11.674-3.772 8.19-7.71 24.692-8.78 36.785a1.238 1.238 0 0 0 .715 1.233l13.333 6.14a1.238 1.238 0 0 0 1.4-.258c8.494-8.674 18.474-22.394 22.246-30.584 2.26-4.909 2.219-11.167-.122-18.096z",
    transform: "translate(-45.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3040",
    fill: "#d1d6de",
    d: "M198.964 9.556a44.124 44.124 0 0 0-4.2-8.989 1.237 1.237 0 0 0-1.205-.555c-.045.006-.34.047-.832.134a41.456 41.456 0 0 1 2.837 7.9c1.647 6.621 1.328 12.719-.924 17.634-3.756 8.2-13.242 22.137-21.145 31.074a1.177 1.177 0 0 1-.793.413.954.954 0 0 1-.178-.007l2.912 1.341a1.238 1.238 0 0 0 1.4-.258c8.494-8.674 18.474-22.394 22.246-30.584 2.262-4.916 2.218-11.174-.118-18.103z",
    transform: "translate(-101.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3041",
    fill: "#fc5023",
    d: "M200.563.011A44.106 44.106 0 0 0 191 2.662a29.693 29.693 0 0 0-10.089 6.38l26.8 11.93a30.044 30.044 0 0 0-1.739-11.417 44.117 44.117 0 0 0-4.2-8.99 1.237 1.237 0 0 0-1.209-.554z",
    transform: "translate(-108.95 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3042",
    fill: "#e1591f",
    d: "M294.936.146a41.458 41.458 0 0 1 2.837 7.9 31.179 31.179 0 0 1 .869 11.03l4.272 1.9c.415-6.572-2.515-15.1-5.94-20.407a1.237 1.237 0 0 0-1.205-.555h-.028c-.095.014-.374.055-.805.132z",
    transform: "translate(-204.156 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_514",
    cx: 4.782,
    cy: 4.782,
    r: 4.782,
    fill: "#8088a0",
    transform: "translate(76.497 19.25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3043",
    fill: "#1accb3",
    d: "M136.468 270.547a3.837 3.837 0 0 0-7.085-.276 1.252 1.252 0 0 0-.062.165l-3.764 12.664a1.951 1.951 0 0 0 1.062 2.344 1.98 1.98 0 0 0 .83.184 1.95 1.95 0 0 0 1.641-.9l7.179-11.1a1.248 1.248 0 0 0 .085-.155 3.812 3.812 0 0 0 .114-2.926z",
    transform: "translate(-62.661 -223.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3044",
    d: "M339.118 115.412a7.579 7.579 0 0 0-9.558 4.849l-1.068 3.269a7.579 7.579 0 1 0 14.408 4.709l1.068-3.269a7.588 7.588 0 0 0-4.85-9.558z",
    className: "cls-7",
    transform: "translate(-231.86 -96.048)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3045",
    fill: "#444966",
    d: "M354.959 94.448a1.236 1.236 0 0 0-1.169-.391l-4.8.965a.366.366 0 0 1-.186-.011l-4.689-1.533a6.318 6.318 0 0 0-7.959 4.038l-1.835 5.614a1.238 1.238 0 0 0 .792 1.561l3.741 1.223a1.238 1.238 0 0 0 1.561-.792l.065-.2a1.524 1.524 0 0 1 1.92-.974l2.269.742a7.22 7.22 0 0 0 9.1-4.614l1.445-4.422a1.239 1.239 0 0 0-.255-1.206z",
    transform: "translate(-236.99 -77.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3046",
    fill: "#ffd422",
    d: "M255.654 216.333a6.509 6.509 0 0 0-9.093 1.357l-8.98 12.128a1.238 1.238 0 0 0 .354 1.8l9.049 5.47a1.237 1.237 0 0 0 1.635-.323l8.393-11.335a6.458 6.458 0 0 0 1.276-3.864 6.531 6.531 0 0 0-2.634-5.233z",
    transform: "translate(-156.064 -179.566)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1742",
    transform: "translate(71.269 36.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3047",
    d: "M255.708 219.923a6.5 6.5 0 0 0-.912-.564 6.533 6.533 0 0 1 1.277 3.868 6.46 6.46 0 0 1-1.276 3.864l-8.393 11.335a1.237 1.237 0 0 1-1.635.323L237.4 234.3c0 .03.007.06.013.089a1.238 1.238 0 0 0 .574.82l9.049 5.47a1.237 1.237 0 0 0 1.635-.323l8.393-11.335a6.458 6.458 0 0 0 1.276-3.864 6.531 6.531 0 0 0-2.632-5.234z",
    className: "cls-10",
    transform: "translate(-227.387 -219.166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3048",
    d: "M203.31 221.794a3.785 3.785 0 0 0-2.564-1.371l-19.834-2.215h-.017a3.81 3.81 0 0 0-.747 7.583L199.981 228h.018q.189.018.376.018a3.81 3.81 0 0 0 2.935-6.231z",
    className: "cls-10",
    transform: "translate(-176.716 -218.189)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1743",
    transform: "translate(50.426 64.989)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3049",
    d: "M63.964 482.356h-12.3a1.238 1.238 0 1 1 0-2.476h12.3a1.238 1.238 0 1 1 0 2.476z",
    className: "cls-11",
    transform: "translate(-50.426 -465.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3050",
    d: "M82.463 439.3H73.82a1.238 1.238 0 1 1 0-2.476h8.644a1.238 1.238 0 1 1 0 2.476z",
    className: "cls-11",
    transform: "translate(-68.925 -429.723)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3051",
    d: "M107.689 396.251h-3.657a1.238 1.238 0 1 1 0-2.476h3.657a1.238 1.238 0 1 1 0 2.476z",
    className: "cls-11",
    transform: "translate(-94.151 -393.775)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3052",
    d: "M184.191 218.952a1.237 1.237 0 0 0-.839-.469l-2.441-.273h-.017a3.81 3.81 0 0 0-.747 7.583l2.236.25a1.237 1.237 0 0 0 1.364-1.063l.695-5.1a1.238 1.238 0 0 0-.251-.928z",
    className: "cls-7",
    transform: "translate(-105.446 -182.18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3053",
    fill: "#1290a4",
    d: "M169.192 325.04a1.238 1.238 0 0 0-.489-.822l-8.46-6.263a1.238 1.238 0 0 0-1.827.412l-13.238 23.738a1.238 1.238 0 0 0 .436 1.659l5.674 3.462a1.237 1.237 0 0 0 1.628-.3l16.034-20.957a1.239 1.239 0 0 0 .242-.929z",
    transform: "translate(-78.982 -265.277)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3054",
    fill: "#075965",
    d: "M241.769 312.335l-17.716-10.711a1.238 1.238 0 0 0-1.635.323l-1.988 2.684a1.222 1.222 0 0 0-.106.171l-.384.688a5.984 5.984 0 0 0 2.086 8.021l11.407 7.044-3.406 12.2a1.238 1.238 0 0 0 .844 1.521l6.381 1.868a1.238 1.238 0 0 0 1.539-.853l5-17.773a4.565 4.565 0 0 0-2.022-5.183z",
    transform: "translate(-140.9 -251.695)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffort);
export default __webpack_public_path__ + "static/media/effort.a00636a81d4485b3980741125e90e602.svg";
export { ForwardRef as ReactComponent };